module.exports = __webpack_public_path__ + "img/l_10174627_004.c7ba3f1a.jpg";